import React from 'react';
import {Background} from './styles.js'
import Fundo from '../../../../assets/backgroundHome.png'


function BackImg(){
    return (
       <Background backgroundImage={Fundo}/>
    )
}

export default BackImg;